import { RiskErrorModel } from '@/types';

export type RiskErrorViewerState = {
  data: RiskErrorModel;
  isOpen: boolean;
  isLoading: boolean;
};

export const riskErrorViewerStateActions = [
  'risk_error_viewer_populate',
  'risk_error_viewer_close',
  'risk_error_viewer_load_start',
  'risk_error_viewer_load_end',
] as const;

export type RiskErrorViewerStateAction = (typeof riskErrorViewerStateActions)[number];
